import React from "react";
import { TextField, Button, Typography } from "@material-ui/core";
import "../Login.css";
import { getQueryStringVariable, isNullOrEmpty } from "../Util";

export function ResetLogin(props) {
	const [password, setPassword] = React.useState("");
	const [confirmPassword, setConfirmPassword] = React.useState("");
	const [hasError, setHasError] = React.useState(false);
	const [msg, setMsg] = React.useState("");

	const changePassword = () => {
		setHasError(false);
		if (password !== confirmPassword) {
			setHasError(true);
			setMsg("Passwords do not match");
			return;
		} else if (isNullOrEmpty(password)) {
			setHasError(true);
			setMsg("Password cannot be empty");
			return;
		}

		fetch("User/SetNewPassword", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				reset: getQueryStringVariable("id"),
				password: password,
			}),
		}).then((x) => {
			document.location.href = "/login";
		});
	};

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				textAlign: "center",
				height: "100%",
				backgroundImage: "url(img/login-background.jpg)",
				backgroundRepeat: "no-repeat",
				backgroundSize: "cover",
			}}>
			<div className="login-wrapper">
				<div>
					<img src="../img/logo.png" alt="Dynamic Elevator Control" className="logo"></img>
				</div>
				<label className="login-label">Please enter your new password.</label>
				<div className="login-control">
					<TextField
						variant="outlined"
						fullWidth={true}
						label="Password"
						onChange={(event) => {
							setPassword(event.currentTarget.value);
						}}
						type="password"></TextField>
				</div>
				<div className="login-control">
					<TextField
						variant="outlined"
						fullWidth={true}
						label="Confirm Password"
						onChange={(event) => {
							setConfirmPassword(event.currentTarget.value);
						}}
						onKeyPress={(event) => {
							if (event.which === 13) {
								changePassword();
							}
						}}
						type="password"></TextField>
				</div>
				{hasError && (
					<Typography color="error" variant="h6">
						{msg}
					</Typography>
				)}
				<Button fullWidth={true} variant="contained" color="primary" className="login-button" onClick={changePassword}>
					Login
				</Button>
			</div>
		</div>
	);
}
